<div class="login-auth-dialog">
  <p class="login-auth-help" translate>label_otp_msg</p>

  <form [formGroup]="otpForm" class="login-auth-form" autocomplete="off">
    <div class="login-field">
      <label for="forgotOtpInput" translate>label_otp_code</label>
      <div class="login-input-icon">
        <img class="input-prefix-icon" src="/assets/images/temp/login-key.svg" alt="" aria-hidden="true" />
        <input formControlName="otpInput" id="forgotOtpInput" type="text" pInputText
          class="has-prefix-icon"
          [placeholder]="'placeholder_enter_otp' | translate"
          [readonly]="isSubmitting" />
      </div>
      <div class="form-errors"
        *ngIf="otpForm.controls.otpInput.errors && (otpForm.controls.otpInput.dirty || otpForm.controls.otpInput.touched)">
        <div *ngIf="otpForm.controls.otpInput.errors.required" translate>invalid_otp</div>
      </div>
    </div>

    <div class="login-auth-actions">
      <button pButton appRipple type="button" class="login-auth-primary"
        [label]="'label_validate_otp' | translate"
        [disabled]="!otpForm.valid || isSubmitting"
        (click)="changePassword($event)"></button>
      <button pButton appRipple type="button" class="login-auth-secondary p-button-outlined"
        [label]="'label_cancel' | translate"
        [disabled]="isSubmitting"
        (click)="closeEditForgot($event)"></button>
    </div>
  </form>
</div>
